// extracted by mini-css-extract-plugin
module.exports = {"container":"pageview_container__1PBBM","title":"pageview_title__1tF3i","content":"pageview_content__2LQcH"};